var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7674 11.8291C4.7674 11.6881 4.7623 11.3152 4.75939 10.8199C3.11076 11.1782 2.76292 10.0244 2.76292 10.0244C2.4933 9.33898 2.10471 9.15651 2.10471 9.15651C1.56656 8.78829 2.14546 8.79594 2.14546 8.79594C2.74036 8.83782 3.05328 9.40745 3.05328 9.40745C3.58196 10.314 4.44029 10.0525 4.77831 9.90059C4.83216 9.51708 4.98535 9.25557 5.15454 9.10734C3.83847 8.95765 2.45473 8.44848 2.45473 6.17507C2.45473 5.5275 2.68578 4.99794 3.06492 4.5831C3.00416 4.43305 2.8004 3.82991 3.12314 3.01298C3.12314 3.01298 3.62089 2.85346 4.75284 3.62122C5.22549 3.48974 5.7327 3.42345 6.23701 3.42126C6.74022 3.42345 7.24707 3.48974 7.72081 3.62122C8.85203 2.85346 9.34906 3.01298 9.34906 3.01298C9.67252 3.82955 9.46913 4.43268 9.408 4.5831C9.78787 4.99794 10.0171 5.5275 10.0171 6.17507C10.0171 8.45431 8.63117 8.95582 7.31074 9.1026C7.52396 9.2858 7.71317 9.64783 7.71317 10.2014C7.71317 10.9947 7.70552 11.6346 7.70552 11.8291C7.70552 11.9879 7.8125 12.1722 8.11341 12.1143C10.4665 11.3283 12.1631 9.10588 12.1631 6.48574C12.1631 3.20893 9.50915 0.552734 6.23591 0.552734C2.96304 0.552734 0.309082 3.20893 0.309082 6.48574C0.309446 9.10661 2.00756 11.3305 4.36279 12.115C4.65897 12.1693 4.7674 11.9861 4.7674 11.8291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.50933b40bda7dfefd8794e0ff51ef056.svg";
export { ForwardRef as ReactComponent };